<template>
  <div>
    <v-container class="my-3" fluid>
      <v-row justify="center">
        <v-col cols="12" md="6">
          <v-card class="pa-4" elevation="7" rounded="lg">
            <v-card-title class="text-center font-weight-bold">
              ลงชื่อเข้าใช้งาน
            </v-card-title>

            <!-- Not authenticated -->
            <div>
              <v-card-text class="text-center"></v-card-text>
              <v-row justify="center" class="mb-4">
                <v-tabs v-model="menuTab" color="blue-darken-2" grow>
                  <v-tab
                    v-for="item in menuItems"
                    :key="item.value"
                    :value="item.value"
                    :class="item.color"
                    @click="item.to ? router.push(item.to) : null"
                    >{{ item.text }}</v-tab
                  >
                </v-tabs>
              </v-row>

              <!-- MODAL -->
              <v-dialog
                v-model="logindialog"
                width="50%"
                max-width="1300"
                class="py-2"
                transition="slide-y-transition"
                persistent
              >
                <v-card
                  max-width="1300"
                  prepend-icon="mdi-account-plus"
                  rounded="lg"
                  class="elevation-10 mb-5 p-0"
                >
                  <v-card-text class="my-0">
                    <v-container class="py-2">
                      <v-row justify="center" align="center">
                        <v-col cols="12"> กรุณากรอกรหัสนักศึกษา </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                            label="รหัสนักศึกษา"
                            variant="outlined"
                            class="mx-auto bg-pink-lighten-2"
                            v-model="reqStudentNum"
                            @input="validateStudentId"
                            :error="!!errorMsg"
                            :error-messages="errorMsg"
                            :count="13"
                            color=""
                            hint="รหัสนักศึกษา 13 หลัก"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <template v-slot:actions>
                    <v-btn
                      class="mb-3 mr-3"
                      variant="elevated"
                      elevation="3"
                      color="green"
                      text="ลงทะเบียน"
                      @click="handlePasswordRequest()"
                      :disabled="!isOkRequest"
                    ></v-btn>
                    <v-btn
                      class="mb-3 mr-3"
                      variant="elevated"
                      elevation="3"
                      color="red"
                      text="ปิด"
                      @click="logindialog = false"
                    ></v-btn>
                  </template>
                </v-card>
              </v-dialog>
              <!-- MODAL END -->
              <v-window v-model="menuTab" class="mt-5">
                <v-window-item
                  :transition="'scroll-x-transition'"
                  :reverse-transition="'scroll-x-reverse-transition'"
                  value="tab1"
                >
                  <v-card flat :transition="'fade-transition'">
                    <v-card-title class="text-center"
                      >ลงชื่อเข้าใช้งาน สำหรับนักศึกษา</v-card-title
                    >
                    <v-row justify="center">
                      <v-col cols="12" sm="8" md="6" lg="4">
                        <v-text-field
                          label="รหัสนักศึกษา"
                          v-model="username"
                          variant="outlined"
                          class="mx-auto mb-3"
                          width="100%"
                          :rules="rules"
                          maxlength="13"
                          @input="filterNonNumeric"
                        ></v-text-field>
                        <v-text-field
                          label="Password"
                          v-model="password"
                          type="password"
                          variant="outlined"
                          class="mx-auto"
                          hide-details
                          autocomplete="off"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-card-actions class="justify-center mt-4">
                      <v-btn
                        @click="handleSignIn"
                        prepend-icon="mdi-account-school"
                        variant="elevated"
                        class="bg-pink-lighten-2"
                        :disabled="!isOkLogin"
                      >
                        Login
                      </v-btn>
                    </v-card-actions>
                    <v-divider class="my-6 border-opacity-30"> </v-divider>

                    <!-- Google OAuth Login (works in LINE external browser) -->
                    <v-row justify="center" class="mb-2">
                      <v-col cols="12" sm="8" md="6" lg="4">
                        <v-btn
                          id="btn-google-login"
                          block
                          variant="outlined"
                          class="google-login-btn"
                          @click="handleGoogleOAuth"
                        >
                          <template v-slot:prepend>
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17.64 9.205c0-.639-.057-1.252-.164-1.841H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"
                                fill="#4285F4"
                              />
                              <path
                                d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z"
                                fill="#34A853"
                              />
                              <path
                                d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z"
                                fill="#FBBC05"
                              />
                              <path
                                d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 6.29C4.672 4.163 6.656 3.58 9 3.58z"
                                fill="#EA4335"
                              />
                            </svg>
                          </template>
                          เข้าสู่ระบบด้วย Google
                        </v-btn>
                      </v-col>
                    </v-row>
                    <!-- END Google OAuth Login -->

                    <template v-slot:actions>
                      <v-btn
                        class="mb-3 mr-3 bg-pink-lighten-2"
                        variant="elevated"
                        elevation="7"
                        text="ขอรับรหัสผ่าน"
                        @click="logindialog = true"
                      ></v-btn>
                      <v-btn
                        class="mb-3 mr-3 text-white"
                        variant="elevated"
                        elevation="7"
                        color="yellow-darken-3"
                        text="ลืมรหัสผ่าน"
                        @click="resetDialog = true"
                      ></v-btn>
                      <!-- <v-btn
                        class="mb-3 mr-3 text-white"
                        variant="elevated"
                        elevation="7"
                        color="blue-darken-4"
                        text="ชมรมศิษย์เก่า"
                        router
                        to="/check_status"
                      ></v-btn> -->
                    </template>
                  </v-card>
                </v-window-item>

                <v-window-item
                  :transition="'scroll-x-transition'"
                  :reverse-transition="'scroll-x-reverse-transition'"
                  value="tab2"
                >
                  <v-card flat :transition="'fade-transition'">
                    <v-card-title class="text-center"
                      >ลงชื่อเข้าใช้งาน สำหรับบุคลากร</v-card-title
                    >
                    <v-row justify="center">
                      <v-col cols="12" sm="8" md="6" lg="4">
                        <v-text-field
                          label="Username"
                          variant="outlined"
                          class="mx-auto"
                          v-model="t_userName"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="8" md="6" lg="4">
                        <v-text-field
                          type="password"
                          label="Password"
                          variant="outlined"
                          class="mx-auto"
                          v-model="t_Password"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-card-actions class="justify-center mt-4">
                      <v-btn
                     @keyup.enter="handleTeacherLogin"
                        :loading="authStore.loading"
                        @click="handleTeacherLogin"
                        prepend-icon="mdi-account"
                        variant="elevated"
                        color="blue-darken-2"
                      >
                        Login
                      </v-btn>
                    </v-card-actions>
                    <!-- <template v-slot:actions>
                      <v-btn
                        :disabled="true"
                        class="mb-3 mr-3"
                        variant="elevated"
                        elevation="7"
                        color="blue-darken-2"
                        text="ลงชื่อขอเข้าใช้งาน"
                        @click="teacherDialog = true"
                      ></v-btn>
                    </template> -->
                  </v-card>
                </v-window-item>
              </v-window>
            </div>

            <!-- MODAL -->
            <v-dialog
              v-model="teacherDialog"
              width="70%"
              max-width="1300"
              class="py-2"
              transition="slide-y-transition"
              persistent
            >
              <v-card
                max-width="1300"
                prepend-icon="mdi-account-plus"
                rounded="lg"
                class="elevation-10 mb-5 p-0"
              >
                <v-card-text class="my-0">
                  <!-- v-form for structure and submission, but validation handled manually -->
                  <v-form @submit.prevent="handleRegistration">
                    <v-container class="py-2">
                      <v-row justify="start" align="start">
                        <v-col cols="12" class="font-weight-bold">
                          กรุณากรอกข้อมูลประจำตัว
                        </v-col>
                        <v-col cols="12" md="5">
                          <v-text-field
                            label="username"
                            variant="outlined"
                            class="mx-auto"
                            v-model="t_reqUsername"
                            color="blue-darken-2"
                            hint="กรุณาจำชื่อผู้ใช้งานของท่าน"
                            autocomplete="username"
                            @input="validateUsername"
                            :error="!!usernameErrorMsg"
                            :error-messages="usernameErrorMsg"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="5">
                          <v-text-field
                            type="email"
                            label="Email"
                            variant="outlined"
                            class="mx-auto"
                            v-model="t_reqEmail"
                            color="blue-darken-2"
                            autocomplete="email"
                            @click="emailErrorMsg = ''"
                            @blur="validateEmail"
                            :error="!!emailErrorMsg"
                            :error-messages="emailErrorMsg"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row justify="start" align="start">
                        <v-col cols="12" md="5">
                          <v-text-field
                            label="password"
                            @click:append-inner="showPassword = !showPassword"
                            :append-inner-icon="
                              showPassword ? 'mdi-eye' : 'mdi-eye-off'
                            "
                            :type="showPassword ? 'text' : 'password'"
                            variant="outlined"
                            class="mx-auto"
                            v-model="t_reqPassword"
                            color="blue-darken-2"
                            autocomplete="new-password"
                            @input="validatePassword"
                            :error="!!passwordErrorMsg"
                            :error-messages="passwordErrorMsg"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="5">
                          <v-text-field
                            @click:append-inner="
                              showConpassword = !showConpassword
                            "
                            :append-inner-icon="
                              showConpassword ? 'mdi-eye' : 'mdi-eye-off'
                            "
                            :type="showConpassword ? 'text' : 'password'"
                            label="Confirm password"
                            variant="outlined"
                            class="mx-auto"
                            v-model="t_reqConpassword"
                            color="blue-darken-2"
                            autocomplete="new-password"
                            @blur="validateConPassword"
                            :error="!!confirmPasswordErrorMsg"
                            :error-messages="confirmPasswordErrorMsg"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row justify="start" align="start">
                        <v-col cols="12" md="2">
                          <v-select
                            label="คำนำหน้า"
                            :items="prefixOptions"
                            v-model="t_reqPrefix"
                            variant="outlined"
                            @update:modelValue="validatePrefix"
                            :error="!!prefixErrorMsg"
                            :error-messages="prefixErrorMsg"
                            required
                          ></v-select>
                        </v-col>
                        <v-col cols="12" md="5">
                          <v-text-field
                            label="ชื่อ"
                            variant="outlined"
                            class="mx-auto"
                            v-model="t_reqFirstName"
                            color="blue-darken-2"
                            autocomplete="given-name"
                            @input="validateFirstName"
                            :error="!!firstNameErrorMsg"
                            :error-messages="firstNameErrorMsg"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="5">
                          <v-text-field
                            label="นามสกุล"
                            variant="outlined"
                            class="mx-auto"
                            v-model="t_reqLastName"
                            color="blue-darken-2"
                            autocomplete="family-name"
                            @input="validateLastName"
                            :error="!!lastNameErrorMsg"
                            :error-messages="lastNameErrorMsg"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>

                <template v-slot:actions>
                  <v-btn
                    class="mb-3 mr-3"
                    variant="elevated"
                    elevation="3"
                    color="green"
                    text="ลงทะเบียน"
                    @click="handleRegistration"
                    :disabled="!isFormGloballyValid"
                  ></v-btn>
                  <v-btn
                    class="mb-3 mr-3"
                    variant="elevated"
                    elevation="3"
                    color="red"
                    text="ปิด"
                    @click="teacherDialog = false"
                  ></v-btn>
                </template>
              </v-card>
            </v-dialog>
            <!-- MODAL END -->

            <!-- resetpassword dialog -->
            <v-dialog
              v-model="resetDialog"
              max-width="750"
              class="py-2"
              transition="slide-y-transition"
              persistent
            >
              <v-card
                max-width="750"
                prepend-icon="mdi-lock-reset"
                rounded="lg"
                class="elevation-10 mb-5 p-0"
              >
                <v-card-text class="my-0">
                  <!-- v-form for structure and submission, but validation handled manually -->
                  <v-form @submit.prevent="">
                    <v-container class="py-2">
                      <v-row justify="start" align="start">
                        <v-col cols="12" class="font-weight-bold">
                          กรุณากรอก Email
                        </v-col>
                        <v-col cols="12" md="5">
                          <v-text-field
                            label="Email"
                            hint="email ต้องลงท้ายด้วย ptu.ac.th"
                            variant="outlined"
                            class="mx-auto"
                            v-model="reset_email"
                            color="blue-darken-2"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>

                <template v-slot:actions>
                  <v-btn
                    class="mb-3 mr-3"
                    variant="elevated"
                    elevation="3"
                    color="green"
                    text="ยืนยัน"
                    @click="handleResetpassword"
                    :disabled="!reset_email"
                  ></v-btn>
                  <v-btn
                    class="mb-3 mr-3"
                    variant="elevated"
                    elevation="3"
                    color="red"
                    text="ปิด"
                    @click="resetDialog = false"
                  ></v-btn>
                </template>
              </v-card>
            </v-dialog>
            <!-- resetpassword dialog end-->

            <!-- Authenticated -->
            <!-- <div v-else>
              <v-card-text>
                <v-row align="center" class="mb-4">
                  <v-col cols="auto">
                    <v-avatar size="64">
                      <v-img
                        :src="authStore.userPhoto"
                        :alt="authStore.userName"
                      />
                    </v-avatar>
                  </v-col>
                  <v-col>
                    <h3>{{ authStore.userName }}</h3>
                    <p class="text-medium-emphasis">
                      {{ authStore.userEmail }}
                    </p>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions class="justify-center">
                <v-btn
                  color="error"
                  :loading="authStore.loading"
                  @click="handleLogout"
                  prepend-icon="mdi-logout"
                  variant="elevated"
                >
                  Sign Out
                </v-btn>
              </v-card-actions>
            </div> -->

            <!-- Error display -->
            <v-alert
              v-if="authStore.error"
              type="error"
              closable
              @click:close="authStore.clearError"
              class="mt-4"
            >
              {{ authStore.error }}
            </v-alert>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useAuthStore } from "@/stores/auth";
const router = useRouter();
const authStore = useAuthStore();
import { useRouter } from "vue-router";

import axios from "axios";
import { getCurrentInstance } from "vue";
const { proxy } = getCurrentInstance();

const menuItems = [
  { text: "นักศึกษา", value: "tab1", class: "bg-pink-lighten-2" },
  { text: "บุคลากร", value: "tab2", class: "bg-blue-darken-2" },
  {
    text: "ชมรมศิษย์เก่า",
    value: "tab3",
    class: "bg-green-lighten-2",
    to: "/check_status", // Use a custom key name like 'to'
  },

  // Add more items as needed
];
const menuTab = ref(null);

//const menuItems = ["นักศึกษา", "บุคลากร"];
const logindialog = ref(false);
const username = ref("");
const password = ref("");
const reqStudentNum = ref("");
const errorMsg = ref("");
const isOkLogin = computed(() => username.value && password.value);
const isOkRequest = computed(() => !errorMsg.value && reqStudentNum.value);
const API_BASE_URL = process.env.VUE_APP_BACKEND_BASE_URL;
// 2. The validation function
const validateStudentId = () => {
  const value = reqStudentNum.value;
  errorMsg.value = ""; // Clear error first

  if (!value) {
    errorMsg.value = "กรุณากรอกรหัสนักศึกษา";
  } else if (!/^\d{13}$/.test(value)) {
    errorMsg.value = "รหัสนักศึกษาต้องเป็นตัวเลข 13 หลัก";
  }
};

const rules = [
  (value) => !!value || "Required.",
  (value) => /^\d/.test(value) || "รหัสนักศึกษา 13 ตัวเท่านั้น",
];

function filterNonNumeric() {
  // Use a regex to remove any character that is not a digit (0-9)
  username.value = username.value.replace(/\D/g, "");
}

const handlePasswordRequest = async () => {
  console.log("handleSignIn called with:", reqStudentNum.value);
  try {
    const response = await axios.post(
      // "http://localhost:3000/passwordRequest",
      `/api/passwordRequest`,
      {
        studentNum: reqStudentNum.value,
      },
      {
        validateStatus: function (status) {
          return (
            (status >= 200 && status < 300) || status === 400 || status === 404
          );
        },
      },
    );

    // Now, you can check the status codes directly in the try block
    if (response.status === 200) {
      logindialog.value = false;
      await proxy.$swal({
        title: "ลงทะเบียนเรียบร้อย!",
        text: `รหัสผ่านของคุณคือ <b>รหัสนักศึกษาตามด้วย PTU</b>`,
        icon: "success",
        showConfirmButton: true,
      });
    } else if (response.status === 404) {
      // Use else if for clarity
      logindialog.value = false;

      await proxy.$swal({
        title: "เกิดข้อผิดพลาด",
        text: `ไม่พบรหัสนักศึกษา ${reqStudentNum.value} กรุณาติดต่อผู้ดูแล`, // Corrected variable usage
        icon: "error",
        showConfirmButton: true,
      });
    } else if (response.status === 400) {
      // Use else if for clarity
      logindialog.value = false;
      await proxy.$swal({
        title: "เกิดข้อผิดพลาด",
        text: `มีรหัสใช้งานอยู่แล้ว กรุณาลงชื่อเข้าใช้แบบปกติ`,
        icon: "error",
        showConfirmButton: true,
      });
    }
  } catch (err) {
    // This catch block will now only be hit for actual network errors,
    // server errors outside your specified statuses, or other unexpected issues.
    console.log("request failed (unexpected error):", err);
    logindialog.value = false;
    await proxy.$swal({
      title: "ERROR",
      text: `เกิดข้อผิดพลาดในการขอรับรหัส`,
      icon: "error",
      timer: 3000,
      showConfirmButton: false,
    });
  }
};
const handleGoogleOAuth = () => {
  // Navigate directly to the Express backend OAuth endpoint.
  // We use VUE_APP_BACKEND_BASE_URL so this works in both dev (port 3000)
  // and production (same origin). Avoids relying on the Vue dev proxy.
  const backendBase = process.env.VUE_APP_BACKEND_BASE_URL || "";
  window.location.href = `${backendBase}/auth/google`;
};

const handleGoogleSignIn = async () => {
  try {
    await authStore.signInWithGoogle();
    // router.push("/dashboard");
  } catch (error) {
    // Error is already handled in the store
  }
};

// On mount: pick up the JWT token that the backend delivers via URL param
// after a successful Google OAuth redirect (e.g. /?token=eyJhb...)
onMounted(async () => {
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get("token");
  const error = urlParams.get("error");

  if (token) {
    // Clean the token out of the URL so it isn't bookmarked or leaked in referer headers
    window.history.replaceState({}, document.title, window.location.pathname);

    authStore.storeBackendJwt(token);

    // Validate and populate user state from the token
    const isValid = await authStore.validateBackendToken(token);
    if (isValid) {
      authStore.drawer = true;
      authStore.rail = true;
      await proxy.$swal({
        title: "เข้าสู่ระบบสำเร็จ!",
        text: "ยินดีต้อนรับ",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });
      router.push("/student_PLO");
    } else {
      // Token was tampered with or expired
      await proxy.$swal({
        title: "เกิดข้อผิดพลาด",
        text: "ไม่สามารถยืนยันตัวตนได้ กรุณาลองใหม่อีกครั้ง",
        icon: "error",
        showConfirmButton: true,
      });
    }
  } else if (error) {
    // Clean the error param out of the URL
    window.history.replaceState({}, document.title, window.location.pathname);

    const errorMessages = {
      invalid_domain:
        "อีเมลที่ใช้ไม่ใช่อีเมลของมหาวิทยาลัย (@ptu.ac.th) กรุณาใช้อีเมลนักศึกษา",
      not_found:
        "ไม่พบข้อมูลนักศึกษาในระบบ กรุณาติดต่อผู้ดูแล",
      auth_failed:
        "การยืนยันตัวตนล้มเหลว กรุณาลองใหม่อีกครั้ง",
      csrf_failed:
        "เกิดข้อผิดพลาดด้านความปลอดภัย กรุณาลองใหม่อีกครั้ง",
      oauth_denied:
        "คุณปฏิเสธการเข้าถึง Google กรุณาอนุญาตเพื่อเข้าสู่ระบบ",
    };

    await proxy.$swal({
      title: "เข้าสู่ระบบไม่สำเร็จ",
      text: errorMessages[error] || `เกิดข้อผิดพลาด: ${error}`,
      icon: "error",
      showConfirmButton: true,
    });
  }
});

const handleSignIn = async () => {
  const authStore = useAuthStore();
  console.log("handleSignIn called with:", username.value);
  authStore.loading = true;
  console.log("Making request to:", "/api/login-with-password");
  console.log("Current window.location:", window.location.href);
  try {
    const response = await axios.post(`/api/login-with-password`, {
      studentNum: username.value,
      password: password.value,
    });

    // This block only runs if the status code is in the 2xx range
    if (response.status === 200) {
      authStore.loading = false;
      await proxy.$swal({
        title: "Login Successful!",
        text: "Welcome back!",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });
      authStore.storeBackendJwt(response.data.token);
      if (response.data.student) {
        authStore.user = { ...response.data.student };
      }
      console.log("debug login response", authStore.user);
      console.log("JWTToken:", authStore.getBackendJwt());
      authStore.drawer = true;
      authStore.rail = true;
      authStore.loading = false;

      router.push("/student_PLO");
    }
  } catch (error) {
    console.error("Login failed:", error);
    authStore.loading = false;

    if (error.response) {
      // The request was made and the server responded with an error status code
      switch (error.response.status) {
        case 401:
          await proxy.$swal({
            title: "Error",
            text: error.response.data.message || "การตรวจสอบสิทธิ์ล้มเหลว",
            icon: "error",
            timer: 3000,
            showConfirmButton: false,
          });
          authStore.loading = false;

          break;
        case 400:
          await proxy.$swal({
            title: "Error",
            text: error.response.data.message || "คำขอไม่ถูกต้อง",
            icon: "error",
            timer: 3000,
            showConfirmButton: false,
          });
          authStore.loading = false;
          break;
        case 404:
          await proxy.$swal({
            title: "Error",
            text: "ปลายทาง API ไม่ถูกต้อง",
            icon: "error",
            timer: 3000,
            showConfirmButton: false,
          });
          authStore.loading = false;
          break;
        case 409:
          await proxy.$swal({
            title: "Error",
            text: "กรุณาลงชื่อออกจากอุปกรณ์เครื่องก่อน",
            icon: "error",
            timer: 3000,
            showConfirmButton: false,
          });
          authStore.loading = false;
          break;
        case 429:
          await proxy.$swal({
            title: "Error",
            text: "คุณเข้าสู่ระบบมากเกินไป โปรดลองอีกครั้งในภายหลัง",
            icon: "error",
            timer: 3000,
            showConfirmButton: false,
          });
          authStore.loading = false;
          break;
        default:
          await proxy.$swal({
            title: "Error",
            text: `เกิดข้อผิดพลาด: ${error.response.status} - ${
              error.response.data.message || "ข้อผิดพลาดที่ไม่รู้จัก"
            }`,
            icon: "error",
            timer: 3000,
            showConfirmButton: false,
          });
          authStore.loading = false;
          break;
      }
    } else if (error.request) {
      // The request was made but no response was received (e.g., server offline)
      await proxy.$swal({
        title: "Error",
        text: "ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้ โปรดตรวจสอบการเชื่อมต่ออินเทอร์เน็ต",
        icon: "error",
        timer: 3000,
        showConfirmButton: false,
      });
      authStore.loading = false;
    } else {
      // Something else happened in setting up the request that triggered an Error
      await proxy.$swal({
        title: "Error",
        text: `เกิดข้อผิดพลาดในการตั้งค่าคำขอ: ${error.message}`,
        icon: "error",
        timer: 3000,
        showConfirmButton: false,
      });
      authStore.loading = false;
    }
  }
};

//teacher
const teacherDialog = ref(false);
const t_reqUsername = ref("");
const t_reqEmail = ref("");
const t_reqPassword = ref("");
const t_reqConpassword = ref("");
const t_reqPrefix = ref(null);
const t_reqFirstName = ref("");
const t_reqLastName = ref("");
console.log(API_BASE_URL);
const showPassword = ref(false);
const showConpassword = ref(false);
const usernameErrorMsg = ref("");
const validateUsername = () => {
  const value = t_reqUsername.value;
  usernameErrorMsg.value = "";
  if (!value) {
    usernameErrorMsg.value = "กรุณากรอกชื่อผู้ใช้";
  } else if (!/^[a-zA-Z0-9_-]+$/.test(value)) {
    usernameErrorMsg.value =
      "ชื่อผู้ใช้ต้องประกอบด้วยตัวอักษรภาษาอังกฤษ, ตัวเลข, ขีดล่าง หรือยัติภังค์เท่านั้น";
  } else if (value.length < 3 || value.length > 20) {
    usernameErrorMsg.value = "ชื่อผู้ใช้ต้องมีความยาวระหว่าง 3-20 ตัวอักษร";
  }
};
const clearInputData = () => {
  t_reqUsername.value = "";
  t_reqEmail.value = "";
  t_reqPassword.value = "";
  t_reqConpassword.value = ""; // Assuming you have a reactive variable for confirm password
  t_reqPrefix.value = "";
  t_reqFirstName.value = "";
  t_reqLastName.value = "";

  // Optional: Also clear any validation error messages
  // usernameError.value = '';
  // emailError.value = '';
  // ... and so on for all your validation error states
};
const emailErrorMsg = ref("");
const validateEmail = () => {
  const value = t_reqEmail.value;
  emailErrorMsg.value = "";
  if (!value) {
    emailErrorMsg.value = "กรุณากรอกอีเมล";
  } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
    emailErrorMsg.value = "รูปแบบอีเมลไม่ถูกต้อง";
  }
};
const passwordErrorMsg = ref("");
const validatePassword = () => {
  const value = t_reqPassword.value;
  passwordErrorMsg.value = "";
  if (!value) {
    passwordErrorMsg.value = "กรุณากรอกรหัสผ่าน";
  } else if (value.length < 7) {
    passwordErrorMsg.value = "รหัสผ่านต้องมีความยาวอย่างน้อย 7 ตัวอักษร";
  } else if (!/^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{}|;:'",.<>/?]{7,}$/.test(value)) {
    passwordErrorMsg.value =
      "รหัสผ่านต้องประกอบด้วยตัวอักษรภาษาอังกฤษ, ตัวเลข, หรืออักขระพิเศษเท่านั้น";
  }
  // Re-validate confirm password if main password changes and confirm password has a value
  if (t_reqConpassword.value) {
    validateConPassword();
  }
};
const confirmPasswordErrorMsg = ref("");
const validateConPassword = () => {
  const value = t_reqConpassword.value;
  confirmPasswordErrorMsg.value = "";
  if (!value) {
    confirmPasswordErrorMsg.value = "กรุณายืนยันรหัสผ่าน";
  } else if (value !== t_reqPassword.value) {
    confirmPasswordErrorMsg.value = "รหัสผ่านไม่ตรงกัน";
  }
};
const prefixErrorMsg = ref("");
const validatePrefix = () => {
  const value = t_reqPrefix.value;
  prefixErrorMsg.value = "";
  if (!value) {
    prefixErrorMsg.value = "กรุณาเลือกคำนำหน้า";
  }
};
const firstNameErrorMsg = ref("");
const validateFirstName = () => {
  const value = t_reqFirstName.value;
  firstNameErrorMsg.value = "";
  if (!value) {
    firstNameErrorMsg.value = "กรุณากรอกชื่อ";
  }
};
const lastNameErrorMsg = ref("");
const validateLastName = () => {
  const value = t_reqLastName.value;
  lastNameErrorMsg.value = "";
  if (!value) {
    lastNameErrorMsg.value = "กรุณากรอกนามสกุล";
  }
};

const isFormGloballyValid = computed(() => {
  return (
    !usernameErrorMsg.value &&
    !emailErrorMsg.value &&
    !passwordErrorMsg.value &&
    !confirmPasswordErrorMsg.value &&
    !prefixErrorMsg.value &&
    !firstNameErrorMsg.value &&
    !lastNameErrorMsg.value &&
    // Also ensure all fields have *some* value, even if validation functions didn't catch it
    // (e.g., if a field is empty but the regex allows empty, the required check needs to be explicit)
    t_reqUsername.value &&
    t_reqEmail.value &&
    t_reqPassword.value &&
    t_reqConpassword.value &&
    t_reqPrefix.value &&
    t_reqFirstName.value &&
    t_reqLastName.value
  );
});
// --- Registration Handler ---
const handleRegistration = async () => {
  // Trigger all validation functions
  validateUsername();
  validateEmail();
  validatePassword();
  validateConPassword();
  validatePrefix();
  validateFirstName();
  validateLastName();

  // Check the overall form validity after running all individual validations
  if (isFormGloballyValid.value) {
    const displayName = `${t_reqPrefix.value} ${t_reqFirstName.value} ${t_reqLastName.value}`;
    authStore.loading = true; // Start loading indicator
    console.log("Form is valid! Submitting registration data:", {
      username: t_reqUsername.value,
      email: t_reqEmail.value,
      password: t_reqPassword.value,
      prefix: t_reqPrefix.value,
      firstName: t_reqFirstName.value,
      lastName: t_reqLastName.value,
      displayName: displayName,
    });

    try {
      const response = await axios.post(
        `/api/teacher/create-account`,
        {
          username: t_reqUsername.value,
          email: t_reqEmail.value,
          password: t_reqPassword.value,
          prefix: t_reqPrefix.value,
          firstName: t_reqFirstName.value,
          lastName: t_reqLastName.value,
        },
        {
          validateStatus: function (status) {
            // All these statuses will be handled within the 'try' block
            return (
              (status >= 200 && status < 300) ||
              status === 400 ||
              status === 409
            );
          },
        },
      );

      if (response.status === 201) {
        await proxy.$swal({
          title: "ลงทะเบียนสำเร็จ",
          text: "คุณจะสามารถใช้งานระบบได้ หลังจากได้รับการยืนยันจากผู้ดูแลระบบ",
          icon: "success",
          timer: 10000,
          showConfirmButton: true,
          customClass: {
            container: "my-swal-container",
          },
        });
        clearInputData();
        teacherDialog.value = false;
      } else if (response.status === 400) {
        // Use else if for clarity
        await proxy.$swal({
          title: "Error",
          text: "เกิดข้อผิดพลาดจาก Frontend", // Consider making this message more specific from backend, e.g., 'Missing required data'
          icon: "error",
          timer: 3000,
          showConfirmButton: false,
          customClass: {
            container: "my-swal-container",
          },
        });
      } else if (response.status === 409) {
        // Use else if for clarity
        await proxy.$swal({
          title: "Error",
          text: "Username หรือ Email นี้ถูกใช้ไปแล้ว",
          icon: "error",
          timer: 3000,
          showConfirmButton: false,
          customClass: {
            container: "my-swal-container",
          },
        });
      }
      // Ensure loading is set to false after ALL successful (per validateStatus) response handling
      authStore.loading = false;
    } catch (error) {
      authStore.loading = false; // Always turn off loading on actual errors
      console.error("API error:", error);
      await proxy.$swal({
        // Use swal for consistency, avoid alert()
        title: "Error",
        text: "เกิดข้อผิดพลาดในการลงทะเบียน โปรดลองอีกครั้ง",
        icon: "error",
        timer: 3000,
        showConfirmButton: false,
        customClass: {
          container: "my-swal-container",
        },
      });
    }
  } else {
    console.log("Form is invalid. Please correct the errors.");
    // No need to set authStore.loading here, as it was never set to true
  }
};
const prefixOptions = [
  "นาย", // Mr.
  "นางสาว", // Ms.
  "นาง", // Mrs.
  "คุณ", // Mr./Ms./Mrs. (gender-neutral, respectful)

  // Academic Ranks (often used as prefixes)
  "ผศ.", // Assistant Professor
  "รศ.", // Associate Professor
  "ศ.", // Professor
  "ดร.", // Doctor (for PhD holders)

  // Other Common Professional Titles (often used in formal settings)
  "อ.", // Teacher/Lecturer (general respectful term for academics)
  "นพ.", // Dr. (Male Doctor, from 'นายแพทย์' - Nai Phaet)
  "พญ.", // Dr. (Female Doctor, from 'แพทย์หญิง' - Phaet Ying)
  "ทพ.", // Dr. (Male Dentist)
  "ทพญ.", // Dr. (Female Dentist)
  "ภก.", // Pharmacist (Male)
  "ภกญ.", // Pharmacist (Female)
  "สพ.", // Veterinarian (Male)
  "สพญ.", // Veterinarian (Female)
  "รศ. ดร.", // Associate Professor Dr. (common combination)
  "ศ. ดร.", // Professor Dr. (common combination)
];
const t_userName = ref("");
const t_Password = ref("");

const handleTeacherLogin = async () => {
  const authStore = useAuthStore();
  console.log(`sign-in attemp from ${t_userName}`);
  authStore.loading = true;

  try {
    const response = await axios.post(
      `/api/teacher/teacher-login`,
      {
        username: t_userName.value,
        password: t_Password.value,
      },
      {
        validateStatus: function (status) {
          // All these statuses will be handled within the 'try' block
          return (
            (status >= 200 && status < 300) ||
            status === 400 ||
            status === 404 ||
            status === 409 ||
            status === 401 ||
            status === 429
          );
        },
      },
    );
    if (response.status === 200) {
      authStore.loading = false;
      await proxy.$swal({
        title: "Login Successful!",
        text: `Welcome ${response.data.teacher.displayName}`,
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });
      authStore.storeBackendJwt(response.data.token);
      if (response.data.teacher) {
        authStore.user = { ...response.data.teacher };
      }
      console.log("debug login response", authStore.user);
      console.log(" teacher - JWTToken:", authStore.getBackendJwt());
      authStore.drawer = true;
      authStore.rail = true;
      authStore.loading = false;
      t_userName.value = "";
      t_Password.value = "";
      router.push("/adminDashboard");
    } else if (response.status === 400) {
      authStore.loading = false;
      await proxy.$swal({
        title: "Login Fail!",
        text: ` ${response.data.message}`,
        icon: "error",
        timer: 3000,
        showConfirmButton: false,
      });
    } else if (response.status === 401) {
      authStore.loading = false;
      await proxy.$swal({
        title: "Login Fail!",
        text: ` ${response.data.message}`,
        icon: "error",
        timer: 3000,
        showConfirmButton: false,
      });
    } else if (response.status === 429) {
      authStore.loading = false;
      await proxy.$swal({
        title: "Login Fail!",
        text: ` ${response.data.message}`,
        icon: "error",
        timer: 3000,
        showConfirmButton: false,
      });
    }
  } catch (err) {
    console.log("internal error", err);
  }
};
const resetDialog = ref(false);
const reset_email = ref("");
const resetform = () => {
  reset_email.value = "";
};
const handleResetpassword = async () => {
  authStore.loading = true;
  if (!reset_email.value.endsWith("@ptu.ac.th")) {
    await proxy.$swal({
      title: "Error",
      text: "Email ต้องลงท้ายด้วย @ptu.ac.th เท่านั้น",
      icon: "error",
      timer: 3000,
      showConfirmButton: false,
      customClass: {
        container: "my-swal-container", // Apply a custom class to the main SweetAlert container
      },
    });
    authStore.loading = false;
    return;
  }
  try {
    const response = await axios.post(
      `/api/forgot-password`,
      {
        email: reset_email.value,
      },
      {
        validateStatus: function (status) {
          return (
            (status >= 200 && status < 300) || status === 404 || status === 400
          );
        },
      },
    );

    if (response.status === 200) {
      console.log("reset password success:", response.data);
      resetDialog.value = false;
      authStore.loading = false;
      resetform();
      await proxy.$swal({
        title: "Success",
        text: `ระบบได้ส่งรหัสผ่านใหม่ไปยัง Email ของท่านแล้ว`,
        icon: "success",
        timer: 3000,
        showConfirmButton: false,
      });
    } else if (response.status === 404) {
      console.log("reset password failed: email not found");
      resetDialog.value = false;
      authStore.loading = false;
      resetform();
      await proxy.$swal({
        title: "Error",
        text: `ไม่พบ Email ที่ท่านกรอก`,
        icon: "error",
        timer: 3000,
        showConfirmButton: false,
      });
    }
  } catch (err) {
    console.log("reset password failed:", err);
    resetDialog.value = false;
    authStore.loading = false;
    resetform();
    await proxy.$swal({
      title: "Error",
      text: `เกิดข้อผิดพลาดในการรีเซ็ตรหัสผ่าน`,
      icon: "error",
      timer: 3000,
      showConfirmButton: false,
    });
  }
};
</script>

<style scoped>
.v-tabs {
  display: flex;
  justify-content: center;
}

/* Improved scroll transitions - smoother and slower */
.scroll-x-transition-enter-active,
.scroll-x-transition-leave-active,
.scroll-x-reverse-transition-enter-active,
.scroll-x-reverse-transition-leave-active {
  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.scroll-x-transition-enter-from {
  transform: translateX(100%);
}

.scroll-x-transition-leave-to {
  transform: translateX(-100%);
}

.scroll-x-reverse-transition-enter-from {
  transform: translateX(-100%);
}

.scroll-x-reverse-transition-leave-to {
  transform: translateX(100%);
}

/* Ensure smooth height transitions */
.v-window__container {
  height: auto !important;
  overflow: hidden;
}

.v-window-item {
  transition: opacity 0.3s ease-in-out;
}

.my-swal-container {
  z-index: 5000 !important;
}

/* Add smooth hover effects for better UX */
.v-btn {
  transition: all 0.2s ease-in-out !important;
}

.v-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12) !important;
}
.my-swal-container {
  z-index: 5000 !important;
}

/* Google OAuth Login Button */
.google-login-btn {
  background-color: #ffffff !important;
  border: 1px solid #dadce0 !important;
  border-radius: 4px !important;
  color: #3c4043 !important;
  font-family: "Google Sans", Roboto, Arial, sans-serif !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  letter-spacing: 0.25px !important;
  text-transform: none !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12) !important;
  transition: box-shadow 0.2s ease, background-color 0.2s ease !important;
}

.google-login-btn:hover {
  background-color: #f8f9fa !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.16) !important;
  border-color: #c6c6c6 !important;
  transform: none !important;
}
</style>
